import { createContext, useContext } from "react";

import { OrganizationDetailResponse } from "~/admins/types/organization";

export const OrganizationDetailContext =
  createContext<OrganizationDetailResponse | null>(null);

export const useOrganizationDetailContext = () => {
  const organization = useContext(OrganizationDetailContext);
  if (!organization)
    throw Error(
      "useOrganizationDetailContext must be used inside OrganizationDetailContext.Provider",
    );
  return organization;
};
